module.exports = __webpack_public_path__ + "img/dark_mode.f0873aae.svg";